import * as S from "./styles";

const TermsAndConditions = () => {
  return (
    <S.TermsAndConditionWrapper>
      <S.Container>
        <S.Contain>
          <h1>Terms and Conditions</h1>
          <div className="text-white">FANXO PLATFORM TERMS OF SERVICE</div>
          <div className="text-white">Effective Date: April 18, 2024</div>
          <div className="text-white">Last Updated Date: September 25th, 2025</div>
          <div className="text-white mt-2 font-thin">
            Welcome to the Fanxo Platform, provided by Mave Technologies (currently a proprietorship
            firm) or any entity that may operate Fanxo in the future (“Fanxo,” “we,” or
            “us”). By accessing or using our website or mobile applications (the
            “Services”), you agree to be bound by these Terms of Service. These Terms
            establish your rights and responsibilities as a user of our Services.
          </div>
          <div className="text-white mt-2 font-thin">
            Note: “Fanxo” may in the future be operated by another legal entity, successor, or affiliate. All references
            to “Fanxo,” “we,” “us,” or “our” in these Terms shall apply to such entity
            without requiring further notice to users.
          </div>

          <div className="text-white my-2 font-semibold">
            1. General Terms
          </div>

          <div className="text-white">1.1 Acceptance of Terms</div>
          <div className="text-white mt-2 font-thin">
            By accessing or using Fanxo (the “Platform”), you agree to be bound by these Terms of Service (“Terms”). If you
            do not agree, you may not use the Platform.
          </div>

          <div className="text-white mt-2">1.2 Eligibility</div>
          <div className="text-white mt-2 font-thin">
            - You must be at least **18 years old** to use Fanxo.
          </div>
          <div className="text-white mt-2 font-thin">
            - Users aged **13-17 years** may only access the platform with verified parental or guardian consent and only for browsing non-financial content.
          </div>
          <div className="text-white mt-2 font-thin">
            - By creating an account, you confirm that you meet the above age requirements and have the legal capacity to enter a binding contract under applicable law, including Indian law or the law of your country of residence.
          </div>
          <div className="text-white mt-2 font-thin">
            - Fanxo is not responsible for any access, use, or participation by individuals who do not meet these age requirements, including if a user misrepresents their age.
          </div>

          <div className="text-white mt-2">1.3 Fanxo’s Role</div>
          <div className="text-white mt-2 font-thin font-semibold">Platform Provider</div>
          <div className="text-white mt-2 font-thin">
            - Fanxo is a platform provider that enables creators to share content and monetize their work, and allows fans to subscribe, message, or purchase content, products, or services from creators.
          </div>
          <div className="text-white mt-2 font-thin">
            - Fanxo may offer various monetization tools for creators, including but not limited to: Paid subscriptions to premium content, Paid communities or groups, Direct paid messaging (paid DMs), Any future monetization features introduced on the Platform.
          </div>
          <div className="text-white mt-2 font-thin font-semibold">No Seller Responsibility</div>
          <div className="text-white mt-2 font-thin">
            - Unless explicitly stated, Fanxo is not the seller of any content, products, or services offered on the Platform.
          </div>
          <div className="text-white mt-2 font-thin">
            - All transactions, agreements, and obligations arising from purchases or subscriptions occur directly between the creator and the fan. Fanxo facilitates payment processing but does not provide, and is not legally bound to provide, transaction-level details (such as individual fan payments or payment processor records), and does not act as a seller or guarantor of the content, products, or services.
          </div>
          <div className="text-white mt-2 font-thin">
            - Fanxo does not assume responsibility for the delivery, quality, legality, or safety of any content, products, or services provided by creators.
          </div>
          <div className="text-white mt-2 font-thin font-semibold">No Guarantee or Endorsement</div>
          <div className="text-white mt-2 font-thin">
            - Fanxo does not guarantee that content or offerings on the Platform will meet your expectations, comply with local laws, or be free from errors or harmful elements.
          </div>
          <div className="text-white mt-2 font-thin">
            - Any reliance on creator content, subscriptions, paid communities, or other offerings is at your own risk.
          </div>
          <div className="text-white mt-2 font-thin font-semibold">Dispute Handling</div>
          <div className="text-white mt-2 font-thin">
            - Fanxo is not responsible for disputes, claims, or disagreements between creators and fans.
          </div>
          <div className="text-white mt-2 font-thin">
            - Users agree to resolve such matters directly with the other party. Fanxo may, at its discretion, assist or moderate communications, but is under no legal obligation to do so.
          </div>
          <div className="text-white mt-2 font-thin font-semibold">Platform Evolution</div>
          <div className="text-white mt-2 font-thin">
            - Fanxo may introduce new features, tools, or monetization methods for creators and fans.
          </div>
          <div className="text-white mt-2 font-thin">
            - The Platform’s role as a facilitator remains the same, and these changes do not create new liabilities for Fanxo regarding creator content, transactions, or interactions.
          </div>

          <div className="text-white mt-2">1.4 Account Registration & Security</div>
          <div className="text-white mt-2 font-thin">
            - You must provide accurate, current, and complete information when creating an account.
          </div>
          <div className="text-white mt-2 font-thin">
            - You are responsible for maintaining the confidentiality of your login credentials.
          </div>
          <div className="text-white mt-2 font-thin">
            - Any activity under your account is deemed to be authorized by you.
          </div>
          <div className="text-white mt-2 font-thin">
            - Creating multiple accounts without Fanxo’s prior approval is prohibited.
          </div>
          <div className="text-white mt-2 font-thin">
            - Fanxo reserves the right to suspend or terminate accounts in case of suspected fraud, impersonation, or misuse.
          </div>

          <div className="text-white mt-2">1.5 Responsibility & Enforcement:</div>
          <div className="text-white mt-2 font-thin">
            - You are solely responsible for all content you post, upload, or share, including messages, subscriptions, and community interactions.
          </div>
          <div className="text-white mt-2 font-thin">
            - Any content that is illegal, infringing, or violates third-party rights is entirely your responsibility, and you assume full legal liability for it.
          </div>
          <div className="text-white mt-2 font-thin">
            - Fanxo may pre-screen content to ensure it generally aligns with community guidelines, but is not legally obligated to do so. It is the responsibility of creators to ensure that all content they post comply with Fanxo’s guidelines and applicable Indian laws. Fanxo is not liable for any illegal, infringing, or harmful content posted by creators or users.
          </div>
          <div className="text-white mt-2 font-thin">
            - Fanxo reserves the right to monitor, remove, or restrict access to content that violates these Terms or our community guidelines as per our discretion.
          </div>
          <div className="text-white mt-2 font-thin">
            - Disputes, claims, or issues arising from content or communications are to be resolved directly between the parties involved. Fanxo may assist at its discretion but is not legally responsible for user interactions.
          </div>
          <div className="text-white mt-2 font-thin">
            - Users are solely responsible for ensuring that their content, actions, and use of the Platform comply with Indian law.
          </div>
          <div className="text-white mt-2 font-thin">
            - Fanxo reserves the right to cooperate with law enforcement authorities or regulators in case of any illegal, harmful, or non-compliant activity.
          </div>

          <div className="text-white mt-2">1.6 Content Ownership & License</div>
          <div className="text-white mt-2 font-thin">
            - Creators retain ownership of their original content.
          </div>
          <div className="text-white mt-2 font-thin">
            - By posting content on Fanxo, you grant Fanxo a non-exclusive, worldwide, royalty-free license to use, display, host, and distribute such content only as necessary to operate and promote the Platform.
          </div>
          <div className="text-white mt-2 font-thin">
            - Fanxo reserves the right to remove any content that violates these Terms or our community guidelines.
          </div>

          <div className="text-white mt-2">1.7 Prohibited Use</div>
          <div className="text-white mt-2 font-thin">
            You agree not to use the Platform for any unlawful or harmful purposes, including:
          </div>
          <div className="text-white mt-2 font-thin">
            - Posting illegal, abusive, defamatory, harassing, or fraudulent content.
          </div>
          <div className="text-white mt-2 font-thin">
            - Impersonating others or misrepresenting your identity.
          </div>
          <div className="text-white mt-2 font-thin">
            - Uploading viruses, malware, or disrupting Platform operations.
          </div>
          <div className="text-white mt-2 font-thin">
            - Spamming, unauthorized advertising, or **leaking restricted/exclusive content** (may result in stricter penalties under applicable Indian law).
          </div>
          <div className="text-white mt-2 font-thin">
            - Violating intellectual property, privacy, or publicity rights of others.
          </div>

          <div className="text-white my-2 font-semibold">
            2. Payment Terms for Users (Fans & Purchasers)
          </div>

          <div className="text-white">2.1 Purchases and Subscriptions</div>
          <div className="text-white mt-2 font-thin">
            - Users may purchase subscriptions, memberships, paid interactions (such as messages), or other services provided by creators through Fanxo.
          </div>
          <div className="text-white mt-2 font-thin">
            - By completing a purchase, you authorize Fanxo and its payment partners to process your payment securely.
          </div>

          <div className="text-white mt-2">2.2 Non-Refundable Policy</div>
          <div className="text-white mt-2 font-thin">
            - All payments—whether subscriptions, one-time purchases, or interactions—are **strictly non-refundable** once content has been unlocked or a service has been delivered. All content and services on Fanxo are digital and personalized; no refund or chargeback shall be issued on grounds of dissatisfaction, subjective quality, or perceived misrepresentation.
          </div>
          <div className="text-white mt-2 font-thin">
            - Fanxo is not responsible to store content, interactions data that is paid for. Fanxo is also not responsible for the content to be available for the full duration of the subscription as well.
          </div>
          <div className="text-white mt-2 font-thin">
            - Fanxo is not responsible for storing or maintaining access to paid content, messages, or interactions beyond their intended use. Once a message, interaction, or any paid content has been delivered to the intended recipient—whether a fan or a creator—Fanxo has no obligation or liability to retain, archive, or make such content available at any later time.
          </div>
          <div className="text-white mt-2 font-thin">
            - Fanxo is not responsible for whether a creator responds to direct messages or interactions. Responding is solely at the discretion of the creator, and Fanxo does not guarantee replies or engagement.
          </div>
          <div className="text-white mt-2 font-thin">
            - **No refunds** will be provided under any circumstance if a creator does not respond, fails to engage, or does not provide the expected level of interaction.
          </div>
          <div className="text-white mt-2 font-thin">
            - Fanxo is a facilitator platform and does not act as the seller or guarantor of any content, products, or services offered by creators. Creators are solely responsible for the content they provide and their engagement with fans. Fanxo is not liable if a creator fails to respond, remove, or update content.
          </div>
          <div className="text-white mt-2 font-thin">
            - Fanxo does not guarantee that content will remain continuously available for the full duration of a subscription; creators may remove or change content at their discretion.
          </div>
          <div className="text-white mt-2 font-thin">
            - Refunds will not be issued for unused subscription periods, partial usage, dissatisfaction with content, or inability to access content due to user-side issues (including device, internet, or payment failures), or due to creator-side actions such as changing, deleting, or modifying content.
          </div>
          <div className="text-white mt-2 font-thin">
            - All payments are non-refundable once content has been unlocked or a service delivered. Any claim for a refund must be supported by verifiable proof, such as payment receipts, transaction IDs, or screenshots. In very exceptional cases, Fanxo reserves the right to evaluate and decide on refund requests at its discretion.
          </div>
          <div className="text-white mt-2 font-thin">
            - Users must notify Fanxo of any payment discrepancies or issues within **24 hours** of the transaction. Claims beyond this period will not be entertained.
          </div>

          <div className="text-white mt-2">2.3 Renewals and Cancellations</div>
          <div className="text-white mt-2 font-thin">
            - Subscriptions automatically renew unless cancelled before the renewal date.
          </div>
          <div className="text-white mt-2 font-thin">
            - Fanxo is not liable to provide recurring notifications, reminders, or detailed updates of each deduction.
          </div>
          <div className="text-white mt-2 font-thin">
            - You can cancel auto-renewal at any time via your Fanxo app or banking apps, but cancellation does not entitle you to a refund of amounts already paid.
          </div>
          <div className="text-white mt-2 font-thin">
            - You are responsible for managing and monitoring your subscriptions.
          </div>
          <div className="text-white mt-2 font-thin">
            - It is your responsibility to check your bank or payment provider statements and manage your subscriptions, renewals, or cancellations via your Fanxo account and respective banking applications.
          </div>

          <div className="text-white mt-2">2.4 Chargebacks and Payment Disputes</div>
          <div className="text-white mt-2 font-thin">
            - Initiating an unjustified chargeback is a violation of these Terms.
          </div>
          <div className="text-white mt-2 font-thin">
            - Fanxo reserves the right to suspend your account, recover the charged amount, and/or report fraudulent activity to payment processors or authorities.
          </div>
          <div className="text-white mt-2 font-thin">
            - Users must notify Fanxo of any payment discrepancies, errors, or issues within **24 hours** of the transaction.
          </div>
          <div className="text-white mt-2 font-thin">
            - Fanxo will not be liable for any claims, losses, or disputes arising from a transaction if a user fails to notify within this period, except as required by applicable law.
          </div>
          <div className="text-white mt-2 font-thin">
            - Upon receiving a valid notification, Fanxo may take a reasonable period to investigate and resolve the issue, which may extend up to **six months**, depending on the nature of the issue and applicable legal or technical requirements.
          </div>
          <div className="text-white mt-2 font-thin">
            - Users acknowledge that the purchase price, fees, and subscription details are clearly displayed in the app before completing a transaction. By proceeding with the transaction, users confirm their understanding and acceptance of the charges.
          </div>
          <div className="text-white mt-2 font-thin">
            - Thus, Users acknowledge and agree that **Fanxo cannot be held liable**, and users cannot hold Fanxo legally responsible, for any errors, disputes, or claims arising from purchases, subscriptions, or services once content has been accessed, delivered, or consumed.
          </div>
          <div className="text-white mt-2 font-thin">
            - Users further acknowledge that multiple steps may be involved in completing a transaction, including payment processing and confirmation delays, and accept full responsibility for payment completion.
          </div>

          <div className="text-white mt-2">2.5 Taxes and Currency</div>
          <div className="text-white mt-2 font-thin">
            - Prices may include applicable taxes, or such taxes may be added at checkout, depending on Indian law or your country’s law.
          </div>
          <div className="text-white mt-2 font-thin">
            - Users are responsible for any additional taxes, fees, or charges imposed by their local jurisdiction.
          </div>
          <div className="text-white mt-2 font-thin">
            - All payments are processed in **INR (₹)** unless otherwise specified. Currency conversions may apply, and additional fees may be charged by your bank or payment provider.
          </div>

          <div className="text-white mt-2">2.6 Invoices and Receipts</div>
          <div className="text-white mt-2 font-thin">
            - Fanxo may provide basic payment confirmations but is not legally obliged to issue tax invoices or GST receipts unless required under law.
          </div>
          <div className="text-white mt-2 font-thin">
            - Until Fanxo’s turnover exceeded the GST registration threshold (₹20 - ₹25 lakh), no GST invoices were issued for past transactions. Fanxo is not responsible for providing invoices, receipts, or payment confirmations for these past transactions.
          </div>
          <div className="text-white mt-2 font-thin">
            - By using Fanxo, users agree to indemnify and hold Fanxo harmless from any claims, losses, or disputes arising from payments, transaction confirmations, or taxation obligations, including any claims related to pricing, payment errors, or non-issuance of invoices.
          </div>

          <div className="text-white my-2 font-semibold">
            3. Payment Terms for Creators
          </div>

          <div className="text-white">3.1 Revenue Share</div>
          <div className="text-white mt-2 font-thin">
            - Creators receive a percentage of earnings from subscriptions, paid messages, and other monetization tools on Fanxo.
          </div>
          <div className="text-white mt-2 font-thin">
            - Fanxo retains a platform fee, which may be subject to change at Fanxo’s discretion.
          </div>
          <div className="text-white mt-2 font-thin">
            - Any historical or personalized platform fee arrangements (such as early-bird reductions or promotional rates) may be revised or updated by Fanxo at its discretion. The applicable fee shall be whichever is higher between the revised standard platform fee or the personalized agreement, unless otherwise stated in writing. Fanxo reserves the right to update or modify platform fees sitewide without prior notice.
          </div>

          <div className="text-white mt-2">3.2 Payout Schedule & Process</div>
          <div className="text-white mt-2 font-thin">
            - Payouts are typically processed on a set cycle (e.g., **15–21 days**), unless otherwise agreed for special cases.
          </div>
          <div className="text-white mt-2 font-thin">
            - Payouts are transferred to the creator’s registered bank account or authorized intermediary, which may be established either through a written agreement or a mutually agreed verbal arrangement with the creator.
          </div>
          <div className="text-white mt-2 font-thin">
            - Fanxo is not responsible for delays caused by banking systems, payment processors, or creator-provided errors in account information.
          </div>

          <div className="text-white mt-2">3.3 Creator Responsibilities</div>
          <div className="text-white mt-2 font-thin">
            - Creators are responsible for providing accurate payment and tax information.
          </div>
          <div className="text-white mt-2 font-thin">
            - Creators are solely responsible for declaring and paying applicable taxes (Income Tax, GST, etc.) on earnings.
          </div>
          <div className="text-white mt-2 font-thin">
            - Creators must comply with Fanxo’s content guidelines, legal obligations, and any contractual obligations for their earnings.
          </div>

          <div className="text-white mt-2">3.4 Handling of Fan Disputes & Chargebacks</div>
          <div className="text-white mt-2 font-thin">
            - Creators are responsible for managing disputes with fans.
          </div>
          <div className="text-white mt-2 font-thin">
            - Fanxo may assist in investigating issues but is not legally responsible for resolving content-related disputes.
          </div>
          <div className="text-white mt-2 font-thin">
            - Any chargebacks, refunds, or disputes that arise post-payout do not obligate Fanxo to compensate the creator.
          </div>

          <div className="text-white mt-2">3.5 Liability & Adjustments</div>
          <div className="text-white mt-2 font-thin">
            - Fanxo reserves the right to adjust future payouts to correct any prior overpayments, underpayments, or amounts refunded to fans due to successful chargebacks, disputes, or refund requests. Creators acknowledge and agree that such deductions may be made from subsequent payouts without prior notice.
          </div>
          <div className="text-white mt-2 font-thin">
            - Fanxo is not responsible for any financial obligations or liabilities arising from a creator’s personal arrangements with intermediaries or managers.
          </div>
          <div className="text-white mt-2 font-thin">
            - Creators must notify Fanxo of any discrepancies, disputes, or errors in payouts within **7 days** of receiving the payout. Claims raised after this period will not be considered, and Fanxo will not be liable for adjustments or corrections beyond this timeframe.
          </div>

          <div className="text-white mt-2">3.6 Exceptional / Case-by-Case Terms</div>
          <div className="text-white mt-2 font-thin">
            - Fanxo may enter into personalized agreements with creators for payout schedules, revenue shares, or other terms.
          </div>
          <div className="text-white mt-2 font-thin">
            - Such agreements are valid only when documented in writing and signed by both parties.
          </div>

          <div className="text-white my-2 font-semibold">
            4. Content & Intellectual Property
          </div>

          <div className="text-white">4.1 Ownership of Creator Content</div>
          <div className="text-white mt-2 font-thin">
            - Creators retain full ownership of the original content they post, share, or upload on Fanxo.
          </div>
          <div className="text-white mt-2 font-thin">
            - Creators are solely responsible for ensuring their content does not infringe upon intellectual property rights, privacy rights, or publicity rights of any third party.
          </div>

          <div className="text-white mt-2">4.2 License to Fanxo</div>
          <div className="text-white mt-2 font-thin">
            - By posting content on Fanxo, creators grant Fanxo a non-exclusive, worldwide, royalty-free license to use, host, display, and distribute the content solely for the purposes of operating, promoting, and improving the Platform.
          </div>
          <div className="text-white mt-2 font-thin">
            - This license does not transfer ownership and may be revoked only upon removal of the content from the Platform.
          </div>

          <div className="text-white mt-2">4.3 Content Restrictions & Prohibited Uses</div>
          <div className="text-white mt-2 font-thin">
            Creators and users agree not to:
          </div>
          <div className="text-white mt-2 font-thin">
            - Post or share content that is illegal, abusive, defamatory, harassing, fraudulent, or otherwise harmful.
          </div>
          <div className="text-white mt-2 font-thin">
            - Impersonate any person or misrepresent their identity.
          </div>
          <div className="text-white mt-2 font-thin">
            - Upload viruses, malware, or attempt to disrupt Fanxo’s operations.
          </div>
          <div className="text-white mt-2 font-thin">
            - Engage in spamming, unauthorized advertising, or **leaking of restricted/exclusive content**.
          </div>
          <div className="text-white mt-2 font-thin">
            - Violate any applicable law or third-party rights in their content or interactions.
          </div>

          <div className="text-white mt-2">4.4 Content Enforcement & Liability</div>
          <div className="text-white mt-2 font-thin">
            - Fanxo reserves the right to monitor, remove, or restrict access to content that violates these Terms or community guidelines.
          </div>
          <div className="text-white mt-2 font-thin">
            - Fanxo is not legally responsible for the content of messages, interactions, or disputes between creators and users.
          </div>
          <div className="text-white mt-2 font-thin">
            - All legal responsibility for content, including illegal or infringing content, rests with the creator or user posting it, and Fanxo may not pre-screen all content.
          </div>

          <div className="text-white mt-2">4.5 Community Guidelines</div>
          <div className="text-white mt-2 font-thin">
            Users and creators must comply with Fanxo’s community rules, which include:
          </div>
          <div className="text-white mt-2 font-thin">
            - No illegal, abusive, defamatory, harassing, fraudulent, or harmful content.
          </div>
          <div className="text-white mt-2 font-thin">
            - No impersonation or misrepresentation of identity.
          </div>
          <div className="text-white mt-2 font-thin">
            - No spamming, unauthorized advertising, or leaking of restricted/exclusive content.
          </div>
          <div className="text-white mt-2 font-thin">
            - No sexually explicit, pornographic, obscene, or adult content, or content that promotes or depicts nudity, sexual acts, or sexual services, in violation of Indian law.
          </div>
          <div className="text-white mt-2 font-thin">
            - All content must comply with applicable Indian laws and regulations.
          </div>
          <div className="text-white mt-2 font-thin">
            - Fanxo may monitor, remove, or restrict access to content that violates these rules at its discretion.
          </div>
          <div className="text-white mt-2 font-thin">
            - Creators are fully responsible for ensuring all content they post follow these guidelines.
          </div>
          <div className="text-white mt-2 font-thin">
            - Violations may result in content removal, account suspension, or termination without liability to Fanxo.
          </div>
          <div className="text-white mt-2 font-thin">
            - Continued use of the Platform constitutes acceptance of these guidelines.
          </div>

          <div className="text-white my-2 font-semibold">
            5. Legal Protections
          </div>

          <div className="text-white mt-2">5.1 Disclaimer of Warranties</div>
          <div className="text-white mt-2 font-thin">
            - Fanxo provides the Platform and its Services on an **“as-is”** and **“as available”** basis.
          </div>
          <div className="text-white mt-2 font-thin">
            - Fanxo does not guarantee the accuracy, reliability, quality, completeness, or security of the Services, content, or any interactions on the Platform.
          </div>
          <div className="text-white mt-2 font-thin">
            - Fanxo is not responsible for technical issues, service interruptions, or errors arising from network, internet, or user devices.
          </div>
          <div className="text-white mt-2 font-thin">
            - All content and services on Fanxo are digital and personalized. Once content is accessed or delivered, **no refund or chargeback** shall be issued on grounds of dissatisfaction, subjective quality, or perceived misrepresentation.
          </div>

          <div className="text-white mt-2">5.2 Limitation of Liability</div>
          <div className="text-white mt-2 font-thin">
            - To the maximum extent permitted by law, Fanxo will not be liable for any indirect, incidental, special, punitive, or consequential damages, including but not limited to loss of profits, data, or business opportunities.
          </div>
          <div className="text-white mt-2 font-thin">
            - Fanxo is a facilitator platform and does not guarantee legality, accuracy, or quality of content or interactions. Any reliance on creator content, subscriptions, or paid interactions is at the user’s or creator’s own risk.
          </div>
          <div className="text-white mt-2 font-thin">
            - Fanxo is not liable for: Content posted by creators or users; Transactions, payments, or disputes between creators and users; Failure of any paid content, subscription, or interaction to meet user expectations.
          </div>
          <div className="text-white mt-2 font-thin">
            - Certain jurisdictions may not allow limitations of liability; in such cases, the liability limitations apply to the extent permitted by law.
          </div>

          <div className="text-white mt-2">5.3 Indemnification</div>
          <div className="text-white mt-2 font-thin">
            - Users and creators agree to indemnify Fanxo from any claims arising from violations of Indian laws, regulations, or these Terms.
          </div>
          <div className="text-white mt-2 font-thin">
            - Users and creators agree to indemnify, defend, and hold harmless Fanxo, its affiliates, and employees from any claims, damages, liabilities, losses, costs, or expenses arising from: Their use of the Platform; Violation of these Terms; Posting or sharing illegal, infringing, or harmful content; Breach of any third-party rights.
          </div>

          <div className="text-white mt-2">5.4 Enforcement & Legal Rights</div>
          <div className="text-white mt-2 font-thin">
            - Creators and users must raise any disputes regarding payments, content, or services within **7 days** of the transaction or payout. Claims beyond this period will not be entertained, and Fanxo shall have no liability for them.
          </div>
          <div className="text-white mt-2 font-thin">
            - Fanxo reserves the right to take any legal or technical action necessary to protect the Platform, its users, and its assets.
          </div>
          <div className="text-white mt-2 font-thin">
            - This includes suspending accounts, blocking access, or cooperating with authorities in case of illegal or harmful activity.
          </div>

          <div className="text-white mt-2">5.5 Platform Development & Technical Limitations</div>
          <div className="text-white mt-2 font-thin">
            - Fanxo is a continuously evolving and technically developing platform. Due to its ongoing development and newness, occasional technical issues, discrepancies, downtime, or unavailability of certain features may occur from time to time.
          </div>
          <div className="text-white mt-2 font-thin">
            - Users and creators acknowledge and understand that such occurrences are inherent to technology-based platforms and agree that Fanxo shall not be held liable for any loss, inconvenience, delay, or interruption arising from such technical issues, updates, or maintenance activities.
          </div>
          <div className="text-white mt-2 font-thin">
            - Fanxo makes reasonable efforts to maintain platform stability but does not guarantee uninterrupted or error-free operation.
          </div>

          <div className="text-white my-2 font-semibold">
            7. Governing Law & Dispute Resolution
          </div>

          <div className="text-white mt-2">7.1 Governing Law</div>
          <div className="text-white mt-2 font-thin">
            - These Terms shall be governed by and construed in accordance with the laws of the **Republic of India**, without regard to conflict of law principles.
          </div>
          <div className="text-white mt-2 font-thin">
            - Fanxo is operated in accordance with the laws of India. Users accessing or using the Platform from outside India do so at their own risk and are responsible for compliance with the laws of their respective jurisdictions. Fanxo makes no representation that the Platform, its content, or services are appropriate or available for use in other countries, and shall not be liable for any consequences, restrictions, or penalties arising from such access or usage under foreign laws.
          </div>

          <div className="text-white mt-2">7.2 Jurisdiction</div>
          <div className="text-white mt-2 font-thin">
            - Any disputes, claims, or proceedings arising under or related to these Terms shall be subject to the **exclusive jurisdiction of the courts in Delhi, India**.
          </div>

          <div className="text-white mt-2">7.3 Dispute Resolution Process</div>
          <div className="text-white mt-2 font-thin">
            - Before initiating legal proceedings, both parties agree to attempt to resolve disputes amicably through negotiation or mediation within **30 days** of written notice.
          </div>
          <div className="text-white mt-2 font-thin">
            - If unresolved, the dispute may be referred to binding arbitration under the **Arbitration and Conciliation Act, 1996**, conducted in English, with the venue in **Delhi**.
          </div>

          <div className="text-white mt-2">7.4 No Class Actions</div>
          <div className="text-white mt-2 font-thin">
            - Users and creators agree that disputes will be resolved individually and not as part of any class, collective, or representative action.
          </div>
          
          <div className="text-white my-2 font-semibold">
            8. Termination & Account Suspension
          </div>

          <div className="text-white mt-2">8.1 By Fanxo</div>
          <div className="text-white mt-2 font-thin">
            - Fanxo reserves the right to suspend, restrict, or terminate any account at its discretion if it suspects:
            Violation of these Terms or applicable law.
            Fraudulent, abusive, or harmful activity.
            Misuse of payment systems or intellectual property.
          </div>

          <div className="text-white mt-2">8.2 By User or Creator</div>
          <div className="text-white mt-2 font-thin">
            - Users and creators may delete or deactivate their accounts at any time through the app or by contacting support.
          </div>
          <div className="text-white mt-2 font-thin">
            - Termination does not affect obligations related to outstanding payments, chargebacks, or legal liabilities incurred prior to closure.
          </div>

          <div className="text-white mt-2">8.3 Post-Termination Rights</div>
          <div className="text-white mt-2 font-thin">
            - Upon termination, access to all premium content, earnings, and account data may be immediately disabled.
          </div>
          <div className="text-white mt-2 font-thin">
            - Fanxo may retain necessary data for legal, accounting, or fraud prevention purposes as permitted by law.
          </div>

          <div className="text-white mt-2">8.4 Effect of Termination</div>
          <div className="text-white mt-2 font-thin">
            - Termination does not waive Fanxo’s rights to recover any due payments or enforce indemnities and legal claims.
          </div>
          <div className="text-white mt-2 font-thin">
            - Any licenses or permissions granted to Fanxo survive termination only as required for audit, dispute resolution, or compliance.
          </div>

          <div className="text-white my-2 font-semibold">
            9. Miscellaneous
          </div>

          <div className="text-white mt-2">9.1 Updates to Terms</div>
          <div className="text-white mt-2 font-thin">
            - Fanxo may update these Terms of Service at any time to reflect legal requirements, platform changes, or operational improvements.
          </div>
          <div className="text-white mt-2 font-thin">
            - Continued use of the Platform after updates constitutes acceptance of the revised Terms.
          </div>

          <div className="text-white mt-2">9.2 Entire Agreement</div>
          <div className="text-white mt-2 font-thin">
            - These Terms, along with any creator-specific agreements, policies, or acknowledgments, constitute the entire agreement between users, creators, and Fanxo.
          </div>
          <div className="text-white mt-2 font-thin">
            - Any prior agreements, promises, or understandings not included in these Terms are superseded.
          </div>

          <div className="text-white mt-2">9.3 Severability</div>
          <div className="text-white mt-2 font-thin">
            - If any provision of these Terms is deemed invalid, illegal, or unenforceable, the remaining provisions will continue in full force and effect.
          </div>

          <div className="text-white mt-2">9.4 Force Majeure</div>
          <div className="text-white mt-2 font-thin">
            - Fanxo is not liable for any failure or delay in performance due to circumstances beyond its reasonable control, including natural disasters, technical failures, or acts of government.
          </div>

          <div className="text-white mt-2">9.5 Waiver</div>
          <div className="text-white mt-2 font-thin">
            - Failure by Fanxo to enforce any right or provision of these Terms does not constitute a waiver of that right.
          </div>

          <div className="text-white mt-2">9.6 Contact Information</div>
          <div className="text-white mt-2 font-thin">
            - For any queries, complaints, or notices related to these Terms, users and creators may contact Fanxo at the email or contact details provided on the Platform.
          </div>

          <div className="text-white my-2 font-semibold">
            10. Case-by-Case Policies & Acknowledgments
          </div>

          <div className="text-white mt-2">10.1 Personalized Agreements</div>
          <div className="text-white mt-2 font-thin">
            - Fanxo may, at its discretion, enter into individual agreements or acknowledgments with specific creators to cover special cases, including but not limited to: Adjusted payout schedules; Personalized revenue share or platform fees; Temporary access to beta features or promotional tools.
          </div>

          <div className="text-white mt-2">10.2 Priority and Conflicts</div>
          <div className="text-white mt-2 font-thin">
            - In the event of a conflict between general platform policies and a personalized agreement, Fanxo reserves the **sole right to determine which policy applies**.
          </div>
          <div className="text-white mt-2 font-thin">
            - Such decisions by Fanxo are final and binding on the creator.
          </div>

          <div className="text-white mt-2">10.3 Legal Effect</div>
          <div className="text-white mt-2 font-thin">
            - Creators acknowledge that case-specific agreements are binding, and any payouts, obligations, or permissions will be handled strictly as per Fanxo’s discretion and written acknowledgment.
          </div>

          <div className="text-white mt-2">10.4 No Guarantee</div>
          <div className="text-white mt-2 font-thin">
            - Case-specific arrangements do not guarantee revenue, engagement, or any particular outcome on the Platform.
          </div>
          <div className="text-white mt-2 font-thin">
            - Fanxo is not liable for any losses, disputes, or claims arising from these personalized agreements, except as expressly stated in the acknowledgment.
          </div>

        </S.Contain>
      </S.Container>
    </S.TermsAndConditionWrapper>
  );
};

export default TermsAndConditions;